import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between flex-wrap gap-3 mb-5" }
const _hoisted_2 = { class: "d-flex align-center flex-wrap gap-2" }

import { onMounted, ref } from 'vue'
import { fetchAdminStats, type StatsPeriod, type StatsResponse } from '@/services/adminStatsApi'
import StatsKpiCards from '@/components/Dashboard/Stats/StatsKpiCards.vue'
import StatsQuestionsChart from '@/components/Dashboard/Stats/StatsQuestionsChart.vue'
import StatsTokenChart from '@/components/Dashboard/Stats/StatsTokenChart.vue'
import StatsTokenConsumers from '@/components/Dashboard/Stats/StatsTokenConsumers.vue'
import StatsRatingChart from '@/components/Dashboard/Stats/StatsRatingChart.vue'
import StatsRecentActivity from '@/components/Dashboard/Stats/StatsRecentActivity.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStatsPage',
  setup(__props) {

const today = new Date().toISOString().slice(0, 10)

const period    = ref<StatsPeriod>('month')
const customFrom = ref<string>(today)
const customTo   = ref<string>(today)
const loading   = ref(false)
const error     = ref<string | null>(null)
const stats     = ref<StatsResponse | null>(null)

async function loadStats() {
  loading.value = true
  error.value = null
  try {
    const dateRange = period.value === 'custom'
      ? { from: customFrom.value, to: customTo.value }
      : undefined
    const res = await fetchAdminStats(period.value, dateRange)
    stats.value = res.data
  } catch (e: any) {
    error.value = e?.response?.data?.message ?? e?.message ?? 'Bir hata oluştu'
  } finally {
    loading.value = false
  }
}

function onPeriodChange() {
  if (period.value !== 'custom') {
    loadStats()
  }
}

function onCustomRangeChange() {
  if (customFrom.value && customTo.value && customFrom.value <= customTo.value) {
    loadStats()
  }
}

onMounted(loadStats)

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "mb-0" }, "Kullanım İstatistikleri", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn_toggle, {
          modelValue: period.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
            onPeriodChange
          ],
          mandatory: "",
          color: "primary",
          variant: "outlined",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { value: "today" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Bugün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "yesterday" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Dün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "week" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Son 7 Gün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "month" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Son 30 Gün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "custom" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Özel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (period.value === 'custom')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_text_field, {
                modelValue: customFrom.value,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((customFrom).value = $event)),
                  onCustomRangeChange
                ],
                type: "date",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"150px"},
                max: customTo.value || _unref(today)
              }, null, 8, ["modelValue", "max"]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-medium-emphasis" }, "—", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: customTo.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((customTo).value = $event)),
                  onCustomRangeChange
                ],
                type: "date",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"150px"},
                min: customFrom.value,
                max: _unref(today)
              }, null, 8, ["modelValue", "min", "max"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "error",
          class: "mb-4",
          closable: "",
          "onClick:close": _cache[3] || (_cache[3] = ($event: any) => (error.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                return _createVNode(_component_v_col, {
                  key: n,
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "card" })
                  ]),
                  _: 1
                })
              }), 64))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "mt-2" }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                return _createVNode(_component_v_col, {
                  key: n,
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, {
                      type: "card",
                      height: "300"
                    })
                  ]),
                  _: 1
                })
              }), 64))
            ]),
            _: 1
          })
        ], 64))
      : (stats.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(StatsKpiCards, {
              questions: stats.value.kpis.questions,
              tokens: stats.value.kpis.tokens,
              rating: stats.value.kpis.rating
            }, null, 8, ["questions", "tokens", "rating"]),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(StatsQuestionsChart, {
                      timeseries: stats.value.question_timeseries
                    }, null, 8, ["timeseries"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(StatsTokenChart, {
                      timeseries: stats.value.token_timeseries
                    }, null, 8, ["timeseries"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(StatsTokenConsumers, {
                      breakdown: stats.value.user_token_breakdown
                    }, null, 8, ["breakdown"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(StatsRatingChart, {
                      distribution: stats.value.rating_distribution,
                      "avg-rating": stats.value.kpis.rating
                    }, null, 8, ["distribution", "avg-rating"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(StatsRecentActivity, {
                      "recent-questions": stats.value.recent_activity.recent_questions,
                      "low-rated": stats.value.recent_activity.low_rated,
                      "recent-comments": stats.value.recent_activity.recent_comments
                    }, null, 8, ["recent-questions", "low-rated", "recent-comments"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})